

export const COLORS = {
    main_bg_color: "#F6F3F9",
    danger_primary: "#F15C61",
    danger_secondary: "rgba(241, 92, 97, 0.2)",
    success_primary: "#3FBEB2",
    success_secondary: "#B2E6E1",
    success_tertiary: "#F0FAF9",

    warning_primary: '#F2994A',
    warning_secondary: "#FFEEE6",

    unreconciled_box_shadow: null,

    white: "#fff",
    black: "#000",

    border_basic: 'rgba(0, 0, 0, 0.1)',

    primary: "#1B4C6C",
    primary_off: "rgba(56, 81, 163, 0.2)",
    primary_off_selected: "rgba(56, 81, 163, 0.04)",
    secondary: "#009A9B",
    tag_bg: "#F8C9A0",
    border: '1px solid rgba(0, 0, 0, 0.1)'

}

export const OUR_COLOR = '#3851A3';
export const THEIR_COLOR = '#9867AC';
export const HIGHLIGHT_BG = '#F1E7DE';